import React, { useState, useEffect } from "react";
import { useAppSelector } from "../../../context-store";
import { useHistory } from "react-router";
import InterviewerService from '../../../services/interviewer/interviewer-service';
import toasterUtils from "../../../utils/toaster-utils";
import InterviewerDashboardRequestParameters from "../../../models/interviewer/request/InterviewerDashboardRequestParameters";
import { SortDirection } from "../../../models/enums/SortDirectionEnum";
import InterviewerDashboardModel from "../../../models/interviewer/response/InterviewerDashboardModel";
import PagedListModel from "../../../models/common/PagedListModel";
import { GeneralPoupConfig, ModalSize } from "../../../models/modal-types";
import modalUtils from "../../../utils/modal-utils";
import ConfirmInterviewPopUp from "./ConfirmInterviewComponent";
import { ConfirmEnum } from "../../../models/enums/ConfirmEnum";
import RatingDetailsPopUp from "../../candidate/dashboard/RatingDetailsComponent";
import { PagingEnum } from "../../../models/enums/IAIEnum";
import masterDataService from "../../../services/master-data-service";
import InterviewerDashboardGridComponent from "./InterviewerDashboardGridComponent";
import AddProfilesStatusUpdateModel from "../../../models/company/addProfiles/request/AddProfilesStatusUpdateModel";
import { GuidEnum } from "../../../models/enums/GuidEnum";
import candidateService from "../../../services/candidate/candidate-service";
import StatusUpdatePopUp from "../../company/add-profiles/StatusUpdateComponent";
import IdNameModel from "../../../models/common/IdNameModel";
import adminCandidateService from "../../../services/admin/admin-candidate-service";
import CanidateStatusRequestModel from "../../../models/admin/candidate/request/CanidateStatusRequestModel";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import dateTimeUtils from "../../../utils/date-utils";
import { Button } from "@mui/material";

interface InterviewerDashboardProps {
    statusList: IdNameModel[];
};

const InterviewerDashboardComponent = (props: InterviewerDashboardProps) => {
    let loggedInUser = useAppSelector((state) => state.authState.loggedInUser);
    const [startDate, setStartDate] = useState<Dayjs | null>(dayjs().subtract(7, 'day'));
    const [endDate, setEndDate] = useState<Dayjs | null>(dayjs());
    const [dashboardPagedList, setDashboardPagedList] = useState<PagedListModel<InterviewerDashboardModel>>();
    const [dashboardList, setDashboardList] = useState<InterviewerDashboardModel[]>([]);
    const [refreshDashboardList, setRefreshDashboardList] = useState<number>(2);
    const history = useHistory();
    const [candidateNameFilter, setCandidateNameFilter] = useState<string>("");
    const [page, setPage] = useState<number>(PagingEnum.page);
    const [pageSize, setPageSize] = useState<number>(PagingEnum.pageSize);
    const [sortColumn, setSortColumn] = useState<string>("InterviewDate");
    const [sortDirection, setSortDirection] = useState<number>(PagingEnum.sortDirection);
    const [pageSizesList, setPageSizesList] = useState<number[]>([]);

    useEffect(() => {
        loadPageSizes();
        getInterviewerDashboard(getSearchFilters(candidateNameFilter, page, pageSize, sortColumn, sortDirection));
    }, []);

    const loadPageSizes = () => {
        masterDataService.loadPageSizesForPaging().then((res) => {
            setPageSizesList(res);
        }).catch((error) => {
            toasterUtils.showError(error);
        });
    };

    const getSearchFilters = (candidateNameFilter: string, page: number, pageSize: number, sortColumn: string, sortDirection: number) => {
        var inputData: InterviewerDashboardRequestParameters = {
            page: page,
            pageSize: pageSize,
            sort: sortColumn,
            sortDir: sortDirection,
            interviewerId: "",
            startDate: dateTimeUtils.getFormattedDate(startDate ? startDate.toDate() : new Date()),
            endDate: dateTimeUtils.getFormattedDate(endDate ? endDate.toDate() : new Date()),
            candidateName: candidateNameFilter,
            interviewTypeId: 0,
            statusId: 0
        };
        return inputData;
    };

    const getInterviewerDashboard = (inputParms: InterviewerDashboardRequestParameters) => {
        if (loggedInUser) {
            setRefreshDashboardList(2);
            inputParms.interviewerId = loggedInUser?.profileId;
            modalUtils.showLoader();
            InterviewerService.loadInterviewerDashboard(inputParms).then((res) => {
                modalUtils.closeModal();
                setDashboardList([]);
                setDashboardPagedList(res);
                setDashboardList(res.items);
                setRefreshDashboardList(refreshDashboardList * 5);
            }).catch((error) => {
                modalUtils.closeModal();
                toasterUtils.showError("Erorr fetching Schedules");
            });
        }
    };

    const onConfirmInterviewActionHandler = (interview: InterviewerDashboardModel) => {
        const config: GeneralPoupConfig = {
            title: !interview.isConfirmedByInterviewer ? "Confirm Interview" : "Interview Details",
            content: (
                <ConfirmInterviewPopUp
                    interviewId={interview.interviewId}
                    candidateId={interview.candidateId}
                    resumeTitle={interview.resumeTitle}
                    isConfirmedByInterviewer={interview.isConfirmedByInterviewer}
                    onConfirmInterview={confirmInterviewHandler}
                />
            ),
            size: ModalSize.LG,
            // className: "model-min-height-500"
        };
        modalUtils.showPopup(config);
    };

    const confirmInterviewHandler = (interviewId: string) => {
        if (loggedInUser) {
            modalUtils.showLoader();
            InterviewerService.ConfirmInterview(interviewId, loggedInUser.profileId).then((res) => {
                modalUtils.closeModal();
                if (!res.isSuccess || res.errorMessages.length > 0) {
                    toasterUtils.showError(res.errorMessages.toString());
                    return;
                }
                toasterUtils.showSuccess(res.informationMessages.toString());
                getInterviewerDashboard(getSearchFilters(candidateNameFilter, page, pageSize, sortColumn, sortDirection));
            }).catch((error) => {
                modalUtils.closeModal();
                toasterUtils.showError("Erorr fetching Details" + error);
            });
        }
    };

    const onRateInterviewActionHandler = (interview: InterviewerDashboardModel) => {
        if (interview.isRated === ConfirmEnum.Yes && interview.allowReRate !== true) {
            InterviewerService.getInterviewRatingDetails(interview.interviewId).then((res) => {
                if (!res.isSuccess || res.errorMessages.length > 0) {
                    toasterUtils.showError(res.errorMessages.toString());
                    return;
                }
                const config: GeneralPoupConfig = {
                    title: "Feedback Report",
                    content: (
                        <RatingDetailsPopUp
                            objRatingDetails={res.data} />
                    ),
                    size: ModalSize.XL,
                    className: "model-rating-details-badge"
                };
                modalUtils.showPopup(config);
            }).catch((error) => {
                toasterUtils.showError("Erorr fetching Schedules");
            });
        } else {
            history.push("/rate-interview/" + interview.interviewId);
        }
    };

    const onPageChangeActionHandler = (newPage: number) => {
        setPage(newPage);
        getInterviewerDashboard(getSearchFilters(candidateNameFilter, newPage, pageSize, sortColumn, sortDirection));
    };

    const onPageSizeChangeActionHandler = (newPageSize: number) => {
        setPageSize(newPageSize);
        setPage(PagingEnum.page);
        getInterviewerDashboard(getSearchFilters(candidateNameFilter, PagingEnum.page, newPageSize, sortColumn, sortDirection));
    };

    const onSortActionHandler = (newSortColumn: string, sortDir: string) => {
        setSortColumn(newSortColumn);
        setSortDirection(sortDir === "asc" ? SortDirection.Asc : SortDirection.Desc);
        getInterviewerDashboard(getSearchFilters(candidateNameFilter, page, pageSize, newSortColumn, sortDir === "asc" ? SortDirection.Asc : SortDirection.Desc));
    };

    const onFilterActionHandler = (filterColumn: string, filterValue: string) => {
        setCandidateNameFilter(filterValue);
        setPage(0);
        getInterviewerDashboard(getSearchFilters(filterValue, 0, pageSize, sortColumn, sortDirection));
    };

    /* Start - Status Update Flow */
    const onStatusUpdateActionHandler = (candidateId: string) => {
        modalUtils.showLoader();
        candidateService.getCandidateStatus(candidateId).then((res) => {
            modalUtils.closeModal();
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            let statusUpdateRequestModel: AddProfilesStatusUpdateModel = {
                profileId: res.data.candidateId,
                userId: GuidEnum.Empty,
                statusId: res.data.statusId,
                comments: res.data.comments || "",
                followUpDate: res.data.followUpDate
            };
            openStatusUpdateModel(statusUpdateRequestModel);
        }).catch((error) => {
            modalUtils.closeModal();
            toasterUtils.showError("Erorr fetching Schedules");
        });
    };

    const openStatusUpdateModel = (statusUpdateRequestModel: AddProfilesStatusUpdateModel) => {
        const config: GeneralPoupConfig = {
            title: "Update Status",
            content: (
                <StatusUpdatePopUp
                    objStatusUpdate={statusUpdateRequestModel}
                    statusList={props.statusList}
                    onCloseStatusUpdate={onCloseStatusUpdateHandler}
                    onStatusUpdate={onStatusUpdateHandler}
                />
            ),
            size: ModalSize.LG,
            className: "model-min-height-500"
        };
        modalUtils.showPopup(config);
    };

    const onCloseStatusUpdateHandler = () => {
        modalUtils.closeModal();
    };

    const onStatusUpdateHandler = (objStatusUpdate: AddProfilesStatusUpdateModel) => {
        let objStatus: CanidateStatusRequestModel = {
            candidateId: objStatusUpdate.profileId,
            statusId: objStatusUpdate.statusId,
            comments: objStatusUpdate.comments,
            followUpDate: new Date(),
            profileId: null,
            userId: GuidEnum.Empty
        }
        modalUtils.showLoader();
        adminCandidateService.saveCandidateStatus(objStatus).then((res) => {
            modalUtils.closeModal();
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            toasterUtils.showSuccess(res.informationMessages.toString());
            getInterviewerDashboard(getSearchFilters(candidateNameFilter, page, pageSize, sortColumn, sortDirection));
        }).catch((error) => {
            modalUtils.closeModal();
            toasterUtils.showError(error);
        });
    };
    /* End - Status Update Flow */

    return (
        <div>
            <div className="card card-white">
                <div className="card-body">
                    <div className="row profile-search-panel">
                        <div className="col-md-4">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label="Start Date"
                                    value={startDate}
                                    onChange={(newValue) => setStartDate(newValue)}
                                    format="YYYY-MMM-DD"
                                    slotProps={{
                                        textField: {
                                            fullWidth: true,
                                            size: "small",
                                            margin: "normal",
                                        },
                                    }}
                                />
                            </LocalizationProvider>
                        </div>
                        <div className="col-md-4">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label="End Date"
                                    value={endDate}
                                    onChange={(newValue) => setEndDate(newValue)}
                                    format="YYYY-MMM-DD"
                                    slotProps={{
                                        textField: {
                                            fullWidth: true,
                                            size: "small",
                                            margin: "normal",
                                        },
                                    }}
                                />
                            </LocalizationProvider>
                        </div>
                        <div className="col-md-4">
                            <Button variant="contained" color="success" disabled={startDate === null || endDate === null} type="submit" onClick={() =>
                                getInterviewerDashboard(
                                    getSearchFilters(candidateNameFilter, page, pageSize, sortColumn, sortDirection)
                                )} sx={{ mt: 2, ml: 2 }}>
                                Search
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card card-white">
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-12">
                            {refreshDashboardList > 2 &&
                                <InterviewerDashboardGridComponent
                                    key={refreshDashboardList}
                                    interviewerDashboardList={dashboardList}
                                    totalSize={dashboardPagedList?.totalCount ? dashboardPagedList?.totalCount : dashboardList.length}
                                    currentPage={page + 1}
                                    pagesize={pageSize}
                                    sortColumn={sortColumn}
                                    sortDirection={sortDirection === SortDirection.Asc ? "asc" : "desc"}
                                    pageSizesList={pageSizesList}
                                    candidateNameFilterValue={candidateNameFilter}
                                    onConfirmInterviewAction={onConfirmInterviewActionHandler}
                                    onRateInterviewAction={onRateInterviewActionHandler}
                                    onPageChangeAction={onPageChangeActionHandler}
                                    onPageSizeChangeAction={onPageSizeChangeActionHandler}
                                    onSortAction={onSortActionHandler}
                                    onFilterAction={onFilterActionHandler}
                                    onStatusUpdate={onStatusUpdateActionHandler} />
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default InterviewerDashboardComponent;